import type { Nota, LancarNotaCommand } from '@/domain/model/Nota';
import type { NotaGateway } from '@/application/port/out/NotaGateway';
import type {
  ListNotasByMatriculaUseCase, LancarNotaUseCase,
} from '@/application/port/in/NotaUseCase';

export class ListNotasByMatriculaUseCaseImpl implements ListNotasByMatriculaUseCase {
  constructor(private readonly gateway: NotaGateway) {}
  execute(matriculaId: string, disciplineId?: string): Promise<Nota[]> {
    return this.gateway.listByMatricula(matriculaId, disciplineId);
  }
}

export class LancarNotaUseCaseImpl implements LancarNotaUseCase {
  constructor(private readonly gateway: NotaGateway) {}
  execute(command: LancarNotaCommand): Promise<Nota> {
    return this.gateway.lancar(command);
  }
}
